import { HttpClient, HttpContext, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../common-http.service';
import { IEmbeddedPaymentResponse } from '../../models/IEmbeddedPaymentResponse';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { IThankYouPageData } from '../../models/IThankYouPageData';
import { IFeeRequest } from '../../models/IFeeRequest';
import { CRITICAL_ERROR } from '../../core/interceptors/errors/critical-error.token';

@Injectable({
  providedIn: 'root'
})
export class EmbeddedPaymentService {

  private httpService = inject(CommonHttpService)

  emfResponseSignal = signal<IEmbeddedPaymentResponse | null>(null);
  thankYouPageDataSignal = signal<IThankYouPageData | null>(null);
  feeSignal = signal<number | null>(null);
  loadingEPF = signal(false);


  constructor(private http: HttpClient, private oidcSecurityService: OidcSecurityService) { }


  postEmbeddedPayment(auctionId: number, lineItems: any[], comment?: string, displayName?: string, discountCode?: string, isFromBidderCommunity?: boolean): Observable<string> {
    const lineItemsString = JSON.stringify(lineItems);
    let body = `auctionId=${auctionId}&lineItems=${encodeURIComponent(lineItemsString)}`;

    if (comment) {
      body += `&comment=${encodeURIComponent(comment)}`;
    }

    if (displayName) {
      body += `&displayName=${encodeURIComponent(displayName)}`;
    }

    if (discountCode) {
      body += `&discountCode=${encodeURIComponent(discountCode)}`;
    }

    if (isFromBidderCommunity) {
      body += `&isFromBidderCommunity=${encodeURIComponent(isFromBidderCommunity)}`;
    }

    this.loadingEPF.set(true);


    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          // return from(this.oidcSecurityService.getAccessToken()).pipe(
          //   switchMap(token => {
          let headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          // if (token && token.trim() !== '') {
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
          // }
          return this.http.post<string>(environment.epfGetToken, body, {
            headers,
            responseType: 'text' as 'json',
            context: new HttpContext().set(CRITICAL_ERROR, true)
          });
          // })}
        } else {
          let headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.http.post<string>(environment.epfGetToken, body, {
            headers,
            responseType: 'text' as 'json',
            context: new HttpContext().set(CRITICAL_ERROR, true)
          });
        }
      }),
      tap(response => {
        console.log('token received:', response);
        this.emfResponseSignal.set({ token: response });
        this.loadingEPF.set(false);

      }),
      catchError((error: HttpErrorResponse) => {

        return throwError(() => error);

      })
    )
  }

  postEmbeddedPaymentSpecialPurchase(auctionId: number, lineItems: any[], comment?: string, discountCode?: string): Observable<IThankYouPageData> {

    const url = `${environment.apiUrl}/v3/special-purchase`;

    const lineItemsString = JSON.stringify(lineItems);
    let body = `auctionId=${auctionId}&lineItems=${encodeURIComponent(lineItemsString)}`;

    if (comment) {
      body += `&comment=${encodeURIComponent(comment)}`;
    }

    if (discountCode) {
      body += `&discountCode=${encodeURIComponent(discountCode)}`;
    }

    // console.log('body', JSON.stringify(body, null, 2));

    this.loadingEPF.set(true);


    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          // return from(this.oidcSecurityService.getAccessToken()).pipe(
          //   switchMap(token => {
          let headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          // if (token && token.trim() !== '') {
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          // console.log('url', url, 'Decoded body:', decodeURIComponent(body));

          // }
          return this.http.post<IThankYouPageData>(url, body, {
            headers,
            context: new HttpContext().set(CRITICAL_ERROR, true)
            // responseType: 'text' as 'json'
          });
          // })}
        } else {
          let headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.http.post<IThankYouPageData>(url, body, {
            headers,
            responseType: 'text' as 'json',
            context: new HttpContext().set(CRITICAL_ERROR, true)
          });
        }
      }),
      tap(response => {
        console.log('token received:', response);
        this.loadingEPF.set(false);

        this.thankYouPageDataSignal.set(response);
      }),
      catchError((error: HttpErrorResponse) => {
        this.loadingEPF.set(false);
        return throwError(() => error);
      })
    )
  }

  postTestPurchase(auctionId: number, lineItems: any[], comment?: string, displayName?: string, discountCode?: string, isFromBidderCommunity?: boolean): Observable<IThankYouPageData> {
    const url = `${environment.apiUrl}/v3/special-purchase/test`;
    const lineItemsString = JSON.stringify(lineItems);
    let body = `auctionId=${auctionId}&lineItems=${encodeURIComponent(lineItemsString)}`;

    if (comment) {
      body += `&comment=${encodeURIComponent(comment)}`;
    }
    if (displayName) {
      body += `&displayName=${encodeURIComponent(displayName)}`;
    }
    if (discountCode) {
      body += `&discountCode=${encodeURIComponent(discountCode)}`;
    }
    if (isFromBidderCommunity) {
      body += `&isFromBidderCommunity=${encodeURIComponent(isFromBidderCommunity)}`;
    }

    this.loadingEPF.set(true);

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        let headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Accept', 'application/json');
        if (authResult.isAuthenticated) {
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
        }
        return this.http.post<IThankYouPageData>(url, body, {
          headers,
          context: new HttpContext().set(CRITICAL_ERROR, true)
        });
      }),
      tap(response => {
        this.loadingEPF.set(false);
        this.thankYouPageDataSignal.set(response);
      }),
      catchError((error: HttpErrorResponse) => {
        this.loadingEPF.set(false);
        return throwError(() => error);
      })
    );
  }

  getThankYouPageData(sessionToken: string): Observable<IThankYouPageData> {

    const url = `${environment.apiUrl}/v3/epf/thank-you/${sessionToken}`;


    return this.httpService.get<IThankYouPageData>(url).pipe(
      tap(response => {
        // console.log('thank you response:', response);
        this.thankYouPageDataSignal.set(response)
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  setThankYouPageData(data: IThankYouPageData) {
    this.thankYouPageDataSignal.set(data);
  }

  getThankYouPageDataSignal() {
    return this.thankYouPageDataSignal;
  }

  getFee(feeParams: IFeeRequest): Observable<number> {

    const auctionId = feeParams.auctionId;
    const url = `${environment.apiUrl}/v3/auctions/${auctionId}/fee-preview`;

    const params = new HttpParams()
      .set('amount', feeParams.amount)
      .set('purchaseType', feeParams.purchaseType);

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
          return this.httpService.get<number>(url, params, headers);
        } else {
          return this.httpService.get<number>(url, params);
        }

      }),
      tap(response => this.feeSignal.set(response)),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }
}
